import React from "react";
import Navbar from "./Navbar";

export interface LayoutProps {
  userEmail?: string;
  userRole?:  string;
  logoutPath?: string;
  csrfToken?: string;
  flash?: { alert?: string; notice?: string };
}

interface Props extends LayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ flash, children }: Props) {
  return (
    <div className="antialiased bg-gray-100 min-h-screen flex flex-col">
      <Navbar />

      <main className="py-8 px-4 flex-1">
        <div className="max-w-6xl mx-auto">
          {flash?.alert && (
            <div className="mb-4 bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg text-sm">
              {flash.alert}
            </div>
          )}
          {flash?.notice && (
            <div className="mb-4 bg-green-50 border border-green-300 text-green-700 px-4 py-3 rounded-lg text-sm">
              {flash.notice}
            </div>
          )}
          {children}
        </div>
      </main>

      <footer className="py-4 text-center text-xs text-white bg-blue-700">
        &copy; {new Date().getFullYear()} Leitor de AFD - Previ
      </footer>
    </div>
  );
}
